import moment from 'moment'

import useVStore from '@vezham/ui/dist/contracts/hooks/useVStore'
import { AuthToken, HQkeys, TokenKeys } from '@vezham/ui/dist/contracts/iam'

import { iam as useIAM } from '@store/iam/actions'

import { sendMessage } from '@utils/iam/utils'

const usePeople = {
  reset: () => {
    useVStore.delete(TokenKeys.ACCOUNT_REFRESH_TOKEN)
    useVStore.delete(TokenKeys.ACCOUNT_ACCESS_TOKEN)
    useVStore.delete(TokenKeys.ACCOUNT_EXPIRES_IN)
    useVStore.delete(TokenKeys.ACCOUNT_DC)
    useVStore.delete(HQkeys.ACTIVE_PEOPLE)
    return
  },
  update: (data: any) => {
    if (!data) return

    useVStore.set(
      TokenKeys.ACCOUNT_REFRESH_TOKEN,
      data[TokenKeys.ACCOUNT_REFRESH_TOKEN]
    )
    useVStore.set(
      TokenKeys.ACCOUNT_ACCESS_TOKEN,
      data[TokenKeys.ACCOUNT_ACCESS_TOKEN]
    )
    useVStore.set(
      TokenKeys.ACCOUNT_EXPIRES_IN,
      data[TokenKeys.ACCOUNT_EXPIRES_IN]
    )
  },
  updateDC: (data: any) => {
    if (!data) return

    useVStore.set(TokenKeys.ACCOUNT_DC, data[TokenKeys.ACCOUNT_DC])
  },
  authenticate: async (data: AuthToken) => {
    const saveToken = (data: AuthToken) => {
      useVStore.set(TokenKeys.ACCOUNT_ACCESS_TOKEN, data.access_token)
      useVStore.set(TokenKeys.ACCOUNT_EXPIRES_IN, data.expires_in)
      if (data.refresh_token) {
        useVStore.set(TokenKeys.ACCOUNT_REFRESH_TOKEN, data.refresh_token)
      }
    }
    const sendToIAM = (data: AuthToken) => {
      const payload: any = {
        [TokenKeys.ACCOUNT_ACCESS_TOKEN]: data.access_token,
        [TokenKeys.ACCOUNT_EXPIRES_IN]: data.expires_in
      }
      if (data.refresh_token) {
        payload[TokenKeys.ACCOUNT_REFRESH_TOKEN] = data.refresh_token
      }
      sendMessage({ method: 'SAVE_ACCOUNT_TOKEN', data: payload })
    }

    saveToken(data)
    sendToIAM(data)
  },
  refresh: async () => {
    const refreshToken = useVStore.get(TokenKeys.ACCOUNT_REFRESH_TOKEN)
    const tokenResponse = await useIAM.refresh({
      refresh_token: refreshToken
    })
    usePeople.authenticate(tokenResponse)
    return tokenResponse
  },
  get: async () => {
    const expiryTime = useVStore.get(TokenKeys.ACCOUNT_EXPIRES_IN)
    const expiryInMins =
      moment.unix(parseInt(expiryTime ?? '')).diff(moment()) / 60000
    if (expiryInMins < 5) {
      await usePeople.refresh()
    }
    return useVStore.get(TokenKeys.ACCOUNT_ACCESS_TOKEN)
  },
  initByCode: async (code: string) => {
    const tokenResponse = await useIAM.refresh({
      refresh_token: code
    })
    tokenResponse.refresh_token = code
    usePeople.authenticate(tokenResponse)
  }
}

export default usePeople
